module.exports = __webpack_public_path__ + "img/baby_mike.3cd08572.jpg";